import React, { useEffect, useRef, useState } from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import Button from "components/CustomButtons/Button.js";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import ModalInfo from "views/Checkout/Modais/ModalInfo";
import InputMask from 'react-input-mask';
import { Autocomplete, TextField, FormControl } from "@mui/material";
import { useCadastroMultaNaoAcompanhadaStore } from "stores/cadastroMultaNaoAcompanhadaStore";
import { FormMultaNaoAcompanhadaButtons } from "../FormMultaNaoAcompanhadaButtons";
import { format } from "date-fns";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ptBR } from "date-fns/locale";
import { serverApi } from "services/constante.js";

export function FormMultaNaoAcompanhadaDadosMulta({ isActive }) {
  const cadastroStore = useCadastroMultaNaoAcompanhadaStore();

  const [dateValue, setDateValue] = useState(cadastroStore.dataInfracao);
  const [hourValue, setHourValue] = useState(cadastroStore.horaInfracao);

  const onSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    const placa = formData.get("placa");
    const dataInfracao = formData.get("dataInfracao");
    const horaInfracao = formData.get("horaInfracao");
    const autoInfracao = formData.get("autoInfracao");
    const autoRenainf = formData.get("autoRenainf");
    const templateIdLabel = formData.get("templateId");
    const local = formData.get("local");
    const orgaoEmissor = formData.get("orgaoEmissor");

    const templateIdValue = cadastroStore.templates.find((template) => template.NomePeticao === templateIdLabel)?.Id;

    const formValues = {
      placa,
      dataInfracao: dateValue,
      formattedDataInfracao: dataInfracao,
      horaInfracao: hourValue,
      formatedHoraInfracao: horaInfracao,
      autoInfracao,
      autoRenainf,
      templateId: templateIdValue,
      enquadramento: templateIdLabel,
      local,
      orgaoEmissor,
    };
    console.log('Multa form values:', formValues);

    cadastroStore.setDadosMulta(formValues);
    cadastroStore.goToNext();
  };

  return (
    <form onSubmit={onSubmit}>
      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <ModalInfo imagem={""} label="Placa" />
          <TextField
            id="Placa"
            name="placa"
            label="Placa"
            margin="dense"
            defaultValue={cadastroStore.placa}
            fullWidth
            inputProps={{ maxLength: 7 }}
            required
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={serverApi.urlPHP + "/images/data-infracao.jpg"} label="Data da infração" />
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <DatePicker
              id="DataInfracao"
              label="Data da infração"
              value={dateValue}
              onChange={setDateValue}
              renderInput={(params) => (
                <TextField
                  {...params}
                  name="dataInfracao"
                  fullWidth
                  required
                />
              )}
            />
          </LocalizationProvider>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={serverApi.urlPHP +  "/images/hora-infracao.jpg"} label="Hora da infração" />
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
            <TimePicker
              label="Hora da infração"
              value={hourValue}
              onChange={setHourValue}
              renderInput={(params) => (
                <TextField
                  {...params}
                  id="HoraInfracao"
                  name="horaInfracao"
                  margin="dense"
                  fullWidth
                  required
                />
              )}
            />
          </LocalizationProvider>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={serverApi.urlPHP + "/images/auto-infracao.jpg"} label="Auto de infração" />
          <TextField
            id="AutoInfracao"
            name="autoInfracao"
            label="Auto de infração"
            margin="dense"
            defaultValue={cadastroStore.autoInfracao}
            fullWidth
            required
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={serverApi.urlPHP + "/images/renainf.jpg"} label="Auto de renainf" />
          <TextField
            id="AutoRenainf"
            name="autoRenainf"
            label="Auto Renaif"
            margin="dense"
            defaultValue={cadastroStore.autoRenainf}
            fullWidth
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={serverApi.urlPHP + "/images/enquadramento.jpg"} label="Enquadramento da infração" />
          <FormControl style={{ marginTop: 26, width: "100%" }}>
            <Autocomplete
              id="TemplateId"
              options={cadastroStore.templates} // Lista de opções
              getOptionLabel={(option) => option.NomePeticao} // Define o que exibir na lista
              defaultValue={cadastroStore.templates.find(template => template.Id === cadastroStore.templateId)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Escolha o artigo correspondente"
                  name="templateId"
                  required
                />
              )}
            />
          </FormControl>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={serverApi.urlPHP + "/images/local.jpg"} label="Local (Descrever o endereço exatamente como aparece no Auto de Infração)" />
          <TextField
            id="Local"
            name="local"
            label="Local da Infração"
            margin="dense"
            defaultValue={cadastroStore.local}
            fullWidth
            required
          />
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={3}></GridItem>
        <GridItem xs={12} sm={12} md={6} >
          <ModalInfo imagem={serverApi.urlPHP + "/images/orgao-emissor.jpg"} label="Órgão emissor" />
          <TextField
            id="OrgaoEmissor"
            name="orgaoEmissor"
            label="Órgão Emissor"
            margin="dense"
            defaultValue={cadastroStore.orgaoEmissor}
            fullWidth
            required
          />
        </GridItem>
      </GridContainer>

      <FormMultaNaoAcompanhadaButtons />
    </form>
  );
}